<template>
  <div class="premium-stub">

    <div class="premium-icon-shell">

      <div class="premium-glow"></div>

      <img
        src="../../assets/premium-stub.png"
        alt="Premium"
        class="premium-icon"
      />

      <span class="premium-spark premium-spark-one"></span>
      <span class="premium-spark premium-spark-two"></span>

    </div>


    <div class="premium-content">

      <div class="premium-label">
        PREMIUM
      </div>

      <h2 class="premium-title">
        Раскройте больше возможностей
      </h2>

      <p class="premium-description">
        У вас пока нет активной премиум-подписки
      </p>

    </div>


    <button
      type="button"
      class="subscribe"
      :disabled="isProcessing"
      @click="handleClick"
    >

      <span
        v-if="isProcessing"
        class="subscribe-loader"
      ></span>

      <template v-else>

        <svg
          viewBox="0 0 20 20"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M10 2.8L12.1 7.1L16.8 7.8L13.4 11.1L14.2 15.8L10 13.6L5.8 15.8L6.6 11.1L3.2 7.8L7.9 7.1L10 2.8Z"
            stroke="currentColor"
            stroke-width="1.35"
            stroke-linejoin="round"
          />
        </svg>

        <span>
          Подключить премиум
        </span>

      </template>

    </button>

  </div>
</template>


<script setup>

import {
  ref
} from "vue";


const emit =
  defineEmits([
    "subscribe"
  ]);


const isProcessing =
  ref(false);


function handleClick() {

  if (
    isProcessing.value
  ) {
    return;
  }


  isProcessing.value =
    true;


  emit(
    "subscribe"
  );


  setTimeout(
    () => {

      isProcessing.value =
        false;

    },
    1000
  );

}

</script>


<style scoped>

/* ============================================================
   PREMIUM EMPTY STATE
============================================================ */

.premium-stub {
  width: 100%;
  max-width: 430px;

  margin:
    34px
    auto
    0;

  box-sizing:
    border-box;

  position:
    relative;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  padding:
    46px
    32px
    36px;

  overflow:
    hidden;

  text-align:
    center;

  background:
    radial-gradient(
      300px 170px at 50% -10%,
      rgba(93, 116, 220, 0.08),
      transparent 68%
    ),
    rgba(255, 255, 255, 0.92);

  border:
    1px solid
    rgba(35, 45, 70, 0.065);

  border-radius:
    26px;

  box-shadow:
    0
    16px
    42px
    rgba(15, 23, 42, 0.055);
}


/* ============================================================
   ICON
============================================================ */

.premium-icon-shell {
  width:
    104px;

  height:
    104px;

  position:
    relative;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  box-sizing:
    border-box;

  margin-bottom:
    23px;

  background:
    linear-gradient(
      145deg,
      #f5f6fb,
      #eceef5
    );

  border:
    1px solid
    rgba(95, 100, 170, 0.08);

  border-radius:
    28px;

  box-shadow:
    0
    12px
    30px
    rgba(55, 60, 110, 0.08);
}


.premium-glow {
  position:
    absolute;

  inset:
    16px;

  background:
    radial-gradient(
      circle,
      rgba(105, 112, 220, 0.18),
      rgba(105, 112, 220, 0)
      70%
    );

  border-radius:
    50%;

  filter:
    blur(6px);
}


.premium-icon {
  width:
    64px;

  height:
    64px;

  position:
    relative;

  z-index:
    2;

  display:
    block;

  object-fit:
    contain;
}


/* ============================================================
   LITTLE SPARKS
============================================================ */

.premium-spark {
  position:
    absolute;

  width:
    5px;

  height:
    5px;

  background:
    #7f93df;

  border-radius:
    50%;

  box-shadow:
    0
    0
    0
    4px
    rgba(105, 125, 220, 0.07);
}


.premium-spark-one {
  top:
    16px;

  right:
    17px;
}


.premium-spark-two {
  left:
    18px;

  bottom:
    20px;

  width:
    3px;

  height:
    3px;

  opacity:
    .55;
}


/* ============================================================
   CONTENT
============================================================ */

.premium-content {
  max-width:
    310px;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;
}


/* ============================================================
   PREMIUM LABEL
============================================================ */

.premium-label {
  min-height:
    20px;

  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  box-sizing:
    border-box;

  padding:
    0
    8px;

  margin-bottom:
    9px;

  color:
    #6c75ad;

  background:
    rgba(100, 110, 190, 0.075);

  border:
    1px solid
    rgba(100, 110, 190, 0.075);

  border-radius:
    7px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    7px;

  line-height:
    1;

  letter-spacing:
    1.1px;
}


/* ============================================================
   TITLE
============================================================ */

.premium-title {
  margin:
    0;

  color:
    #353a43;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    17px;

  line-height:
    1.3;

  letter-spacing:
    -0.35px;
}


/* ============================================================
   DESCRIPTION
============================================================ */

.premium-description {
  max-width:
    270px;

  margin:
    8px
    0
    0;

  color:
    #9197a0;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    10px;

  line-height:
    1.5;
}


/* ============================================================
   SUBSCRIBE BUTTON
============================================================ */

.subscribe {
  min-width:
    190px;

  min-height:
    43px;

  margin-top:
    25px;

  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  gap:
    8px;

  box-sizing:
    border-box;

  padding:
    0
    18px;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #687dd5,
      #596ab8
    );

  border:
    1px solid
    rgba(80, 90, 175, 0.10);

  border-radius:
    12px;

  box-shadow:
    0
    9px
    20px
    rgba(80, 95, 185, 0.20);

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;

  cursor:
    pointer;

  transition:
    transform .18s ease,
    box-shadow .18s ease,
    opacity .18s ease;
}


.subscribe svg {
  width:
    15px;

  height:
    15px;

  flex:
    0
    0
    15px;
}


.subscribe:hover:not(:disabled) {
  transform:
    translateY(-1px);

  box-shadow:
    0
    12px
    25px
    rgba(80, 95, 185, 0.26);
}


.subscribe:active:not(:disabled) {
  transform:
    scale(.985);
}


.subscribe:disabled {
  cursor:
    default;

  opacity:
    .72;
}


/* ============================================================
   BUTTON LOADER
============================================================ */

.subscribe-loader {
  width:
    14px;

  height:
    14px;

  box-sizing:
    border-box;

  border:
    2px solid
    rgba(255, 255, 255, 0.35);

  border-top-color:
    #ffffff;

  border-radius:
    50%;

  animation:
    premiumSpin
    .65s
    linear
    infinite;
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.premium-stub {
  background:
    radial-gradient(
      320px 190px at 50% -10%,
      rgba(105, 120, 210, 0.10),
      transparent 68%
    ),
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(255, 255, 255, 0.065);

  box-shadow:
    0
    18px
    44px
    rgba(0, 0, 0, 0.20);
}


html[data-theme="dark"]
.premium-icon-shell {
  background:
    linear-gradient(
      145deg,
      #2a2c34,
      #24262d
    );

  border-color:
    rgba(255, 255, 255, 0.06);

  box-shadow:
    0
    12px
    28px
    rgba(0, 0, 0, 0.24);
}


html[data-theme="dark"]
.premium-glow {
  background:
    radial-gradient(
      circle,
      rgba(120, 135, 235, 0.20),
      rgba(120, 135, 235, 0)
      70%
    );
}


html[data-theme="dark"]
.premium-spark {
  background:
    #91a5ef;

  box-shadow:
    0
    0
    0
    4px
    rgba(120, 140, 235, 0.07);
}


html[data-theme="dark"]
.premium-label {
  color:
    #aab4e8;

  background:
    rgba(120, 135, 220, 0.085);

  border-color:
    rgba(130, 145, 225, 0.09);
}


html[data-theme="dark"]
.premium-title {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.premium-description {
  color:
    #7f858f;
}


html[data-theme="dark"]
.subscribe {
  background:
    linear-gradient(
      135deg,
      #6175c3,
      #4e5d9f
    );

  border-color:
    rgba(140, 150, 230, 0.08);

  box-shadow:
    0
    10px
    24px
    rgba(0, 0, 0, 0.23);
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 430px) {

  .premium-stub {
    width:
      calc(100% - 20px);

    margin:
      22px
      auto
      0;

    padding:
      38px
      20px
      30px;

    border-radius:
      23px;
  }


  .premium-icon-shell {
    width:
      92px;

    height:
      92px;

    margin-bottom:
      20px;

    border-radius:
      25px;
  }


  .premium-icon {
    width:
      56px;

    height:
      56px;
  }


  .premium-title {
    font-size:
      16px;
  }


  .premium-description {
    font-size:
      10px;
  }


  .subscribe {
    min-width:
      180px;

    min-height:
      42px;

    margin-top:
      22px;

    font-size:
      10px;
  }

}


/* ============================================================
   ANIMATIONS
============================================================ */

@keyframes premiumSpin {

  to {
    transform:
      rotate(360deg);
  }

}


@media (prefers-reduced-motion: reduce) {

  .subscribe,
  .subscribe-loader {
    transition:
      none;

    animation-duration:
      0s;
  }

}

</style>